import { z } from 'zod';

import { apiGet } from '../client';

/**
 * Plans bought with Apple in the Dale Negocios iPhone app (GET
 * /v1/business/billing/apple). The CRM only reads who collects: a plan Apple
 * collects for is changed or cancelled on the iPhone, never here.
 */

export const APPLE_BILLING_QUERY_KEY = ['billing', 'apple'];

const AppleBillingSchema = z.object({
  data: z.object({
    collectedBy: z.enum(['apple', 'web']).nullable(),
    plan: z.enum(['base', 'pro', 'max', 'ultra']).nullable(),
    expiresAt: z.string().nullable(),
  }),
});
export type AppleBilling = z.infer<typeof AppleBillingSchema>['data'];

/** Null when Apple billing is not available on this server (503) or cannot be read: the page behaves as before. */
export async function getAppleBilling(): Promise<AppleBilling | null> {
  try {
    return (await apiGet('/v1/business/billing/apple', AppleBillingSchema)).data;
  } catch {
    return null;
  }
}
